import { InjectionToken, Type } from '@angular/core';

import { TaskType } from '../models/task.interface';

export interface TaskDetailsRenderer {
  readonly type: TaskType;
  readonly component: Type<unknown>;
}

export const TASK_DETAILS_RENDERERS = new InjectionToken<TaskDetailsRenderer[]>('TASK_DETAILS_RENDERERS');
